/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import clsx from "clsx";
import { Dropdown } from "react-bootstrap";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../_helpers";
import { useLang, setLanguage } from "../../../../i18n";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";

const languages = [
  {
    lang: "en",
    name: "English",
    flag: toAbsoluteUrl("/media/svg/flags/226-united-states.svg"),
  },
  // {
  //   lang: "zh",
  //   name: "Mandarin",
  //   flag: toAbsoluteUrl("/media/svg/flags/015-china.svg"),
  // },
  // {
  //   lang: "es",
  //   name: "Spanish",
  //   flag: toAbsoluteUrl("/media/svg/flags/128-spain.svg"),
  // },
  // {
  //   lang: "ja",
  //   name: "Japanese",
  //   flag: toAbsoluteUrl("/media/svg/flags/063-japan.svg"),
  // },
  // {
  //   lang: "de",
  //   name: "German",
  //   flag: toAbsoluteUrl("/media/svg/flags/162-germany.svg"),
  // },
  // {
  //   lang: "fr",
  //   name: "French",
  //   flag: toAbsoluteUrl("/media/svg/flags/195-france.svg"),
  // },
];

export default function LanguageSelectorDropdown() {
  const lang = useLang();
  const currentLanguage = languages.find((x) => x.lang === lang);
  return (
    <Dropdown drop="left">
      <Dropdown.Toggle as={DropdownTopbarItemToggler} id="dropdown-toggle-my-cart">
        <div className="navi-item px-8 cursor-pointer bg-hover pr-125 pl-125 ">
          <div className="navi-link profile-item-div">
            <div className="navi-text" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
              <div className="font-weight-bold cursor-pointer profile-item-name">Language</div>
              <div className="btn btn-icon btn-clean btn-xl" style={{ background: "#f5f8fa", width: "100px", marginLeft: "32px" }}>
                <div style={{ fontSize: "0.85rem" }}>{currentLanguage.name}</div>
                <span>
                  <img className="h-20px w-20px rounded" style={{ marginLeft: ".5rem" }} src={currentLanguage.flag} alt={currentLanguage.name} />
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id="language-panel-tooltip">Select Language</Tooltip>
          }
        >
          <div className="btn btn-icon btn-clean btn-dropdown btn-lg mr-1">
            <img
              className="h-25px w-25px rounded"
              src={currentLanguage.flag}
              alt={currentLanguage.name}
            />
          </div>
        </OverlayTrigger> */}
      </Dropdown.Toggle>
      <Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround" style={{ width: "190px" }}>
        <ul className="navi navi-hover py-4 pl-125 pr-125 bg-hover">
          {languages.map((language) => (
            <li
              key={language.lang}
              className={clsx("navi-item", {
                active: language.lang === currentLanguage.lang,
              })}
            >
              <a href="#" onClick={() => setLanguage(language.lang)} className="navi-link" style={{ paddingLeft: "8px", paddingRight: "1px" }}>
                <span className="symbol symbol-20 mr-3">
                  <img src={language.flag} alt={language.name} />
                </span>
                <span className="navi-text" style={{ color: "#7e8299", fontWeight: 500, fontSize: "1.075rem" }}>
                  {language.name}
                </span>
              </a>
            </li>
          ))}
        </ul>
      </Dropdown.Menu>
    </Dropdown>
  );
}
